import fetchFromApiServer from '../../../services/api';

export function validateLogin(requestObject) {
  const url = `users/login`;
  return fetchFromApiServer('POST', url, requestObject);
}
